import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import hero from '../../assets/img/hero.jpg';

function HeroSection() {
  return (
    <>
    {/* Top Navbar */}
      <div
      className="relative bg-cover bg-center h-[300px] text-white"
      style={{ backgroundImage: `url(${hero})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black opacity-50"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto h-full flex items-center px-4 lg:px-8 font-mono gap-2 text-xl">
        <Link to="https://supersprings.co.in/" className="hover:underline text-lg flex gap-3 items-center font-bold ">Home</Link><span className="font-bold">{' > '}</span><p className="ltr font-bold"> Product</p>
      </div>
    </div>
    </>
  )
}

export default HeroSection;